import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export const WhyItFailed = () => {
  const reasons = ['Los métodos de "dejarlo llorar" hasta el agotamiento generan una ansiedad que impide el sueño profundo.', 'Los manuales americanos no entienden la luz, el ruido y los horarios de vida en España.', 'Confiar en "muletas" de sueño (pecho, biberón o movimiento) solo entrena al bebé para despertarse cada vez que esas muletas desaparecen.', 'Intentar cansarlo más durante el día solo genera cortisol, la hormona que lo mantiene alerta por la noche.'];
  return <section className="py-16 md:py-24 px-6 max-w-4xl mx-auto" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="space-y-12" data-id="element-109">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-charcoal" data-id="element-110">
          Por qué lo que has intentado no ha funcionado
        </h2>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-111">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-sand/30 flex items-start space-x-4" data-id="element-112">
              <XCircle className="text-terracotta shrink-0 mt-1" size={24} data-id="element-113" />
              <p className="text-charcoal/80 leading-relaxed" data-id="element-114">{reason}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
};